import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Toaster from "../../component/Toaster";
import { dashboardAction } from "../../store/dashboard/dashboardSlice";

export function Weeks() {
  const { t } = useTranslation();
  const [weekData, setWeekData] = useState<any>({});
  const dispatch = useDispatch<any>();
  const getWeekData = () => {
    dispatch(dashboardAction({ apiAction: "twoWeekConsecutiveAbsent" }))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          setWeekData(result?.payload?.data?.data);
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {
        // This console for debug the app if any error occurred in DEV
        console.log(err);
      });
  };

  const options = {
    indexAxis: "y" as const,
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        display: false,
        position: "top" as const,
      },
      title: {
        display: true,
      },
    },
    scales: {
      x: {
        border: { dash: [4, 4] }, // for the grid lines
        beginAtZero: true,
      },
    },
  };

  const labels = [""];

  const data = {
    labels: labels,
    datasets: [
      {
        label: "Dataset 1",
        data: [weekData["Total Consecutive Absent"]],
        borderColor: "#C9DDAF",
        backgroundColor: "#C9DDAF",
        borderRadius: 5,
        barThickness: 35,
        maxBarThickness: 40,
      },
    ],
  };

  useEffect(() => {
    getWeekData();
  }, []);

  return (
    <div className="padding-20 padding-down-15 ">
      <div className=" dashboard-heading padding-y-10 ">
        <div className="font-14 bolder">{t("weeksConsecutiveAbsentees")}</div>
      </div>
      <div className="padding-y-10 margin-down-10">
        <Bar options={options} data={data} height={80} className="barchart" />
        <div className="consecutiveAbsentLabel">{`From ${weekData["From to Date"]}`}</div>
      </div>
    </div>
  );
}
